<div class="relative min-h-[600px]">
  <div class="relative">
    <span
      mat-dialog-title
      class="block w-fit max-w-[calc(100%-48px)] text-3xl font-bold"
    >
      Állomás szerkesztése
    </span>
    <button
      mat-icon-button
      mat-dialog-close
      color="primary"
      class="absolute top-0 right-0 scale-125"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div
    *ngIf="loading"
    class="absolute inset-0 z-10 flex items-center justify-center bg-white"
  >
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <div class="dialog-content" *ngIf="!loading">
    <form [formGroup]="editForm!" class="px-4">
      <div class="flex flex-col gap-6 md:flex-row">
        <div class="flex-1">
          <mat-form-field appearance="standard" class="w-full">
            <mat-label>Állomás neve magyarul</mat-label>
            <input matInput formControlName="nameHu" />
          </mat-form-field>

          <mat-form-field appearance="standard" class="w-full">
            <mat-label>Állomás neve angolul</mat-label>
            <input matInput formControlName="nameEn" />
          </mat-form-field>

          <div class="flex gap-4">
            <mat-form-field appearance="standard" class="w-32">
              <mat-label>Irányítószám</mat-label>
              <input matInput formControlName="postalCode" />
            </mat-form-field>

            <mat-form-field appearance="standard" class="flex-1">
              <mat-label>Város</mat-label>
              <input matInput formControlName="city" />
            </mat-form-field>
          </div>

          <mat-form-field appearance="standard" class="w-full">
            <mat-label>Utca és házszám</mat-label>
            <input matInput formControlName="address" />
          </mat-form-field>

          <mat-form-field appearance="standard" class="w-full">
            <mat-label>Elérhetőség</mat-label>
            <input matInput formControlName="contactPhone" />
          </mat-form-field>

          <div class="mb-4">
            <p class="mb-2 text-sm font-medium">Állomás státusza</p>
            <mat-radio-group formControlName="status" class="flex gap-6">
              <mat-radio-button
                [value]="AdminStationStatus.AVAILABLE"
                color="primary"
                >Elérhető</mat-radio-button
              >
              <mat-radio-button
                [value]="AdminStationStatus.NOT_AVAILABLE"
                color="primary"
                >Nem elérhető</mat-radio-button
              >
            </mat-radio-group>
          </div>

          <div class="mb-4">
            <p class="mb-2 text-sm font-medium">Reptéri állomás?</p>
            <mat-radio-group formControlName="isAirport" class="flex gap-6">
              <mat-radio-button [value]="true" color="primary">Igen</mat-radio-button>
              <mat-radio-button [value]="false" color="primary">Nem</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <div class="flex-1">
          <div class="mb-2 space-y-4 rounded-lg bg-light-cyan p-3">
            <p class="mb-3 text-sm font-medium">Elérhető szolgáltatások</p>

            <div class="flex flex-col gap-2">
              <mat-checkbox formControlName="hasBabySeat" color="primary">
                Babaülés
              </mat-checkbox>

              <mat-checkbox formControlName="hasBoosterSeat" color="primary">
                Ülésmagasító
              </mat-checkbox>

              <mat-checkbox formControlName="hasSnowChains" color="primary">
                Hólánc
              </mat-checkbox>

              <mat-checkbox formControlName="hasChildSeat" color="primary">
                Gyerekülés
              </mat-checkbox>

              <mat-checkbox formControlName="hasPhoneHolder" color="primary">
                Telefontartó
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div
    mat-dialog-actions
    class="mb-0 mt-8 flex flex-col justify-end gap-4 border-t border-light-gray pt-6 md:flex-row md:border-none md:pt-0"
  >
    <button
      mat-stroked-button
      color="primary"
      (click)="onCancel()"
      [disabled]="loading"
      class="mol-btn-stroked-primary md:mol-btn-lg h-12 w-full rounded-2xl text-base font-bold md:h-16 md:max-w-[380px]"
    >
      Mégse
    </button>
    <button
      mat-flat-button
      color="primary"
      (click)="onSave()"
      [disabled]="loading || !editForm?.valid"
      class="md:mol-btn-lg ml-0 h-12 w-full rounded-2xl text-base font-bold md:h-16 md:max-w-[380px]"
    >
      Módosítás
    </button>
  </div>
</div>
